// extracted by mini-css-extract-plugin
export default {"container":"WhitepaperPage_container__733Vj"};